import ProfessionalCompany from '../../components/professional-company/ProfessionalCompany';

export function EmployeePage() {
  return <ProfessionalCompany></ProfessionalCompany>;
}
